export default __webpack_public_path__ + "static/media/aidirector-profile.8045ab81.png";